export default __webpack_public_path__ + "static/media/Scope-3.248d8f58.png";